module.exports = __webpack_public_path__ + "img/logo13.b7d40872.png";